import {
  Box,
  Container, FormControl, HStack, Text, useRadio, useRadioGroup, useToast, VStack
} from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logos/s-logo.svg";
import Button from "components/Button/Button";
import constant from "config/constant";
import secondsToMilliseconds from "date-fns/secondsToMilliseconds";
import useAuth from "hooks/useAuth";
import useDebounce from "hooks/useDebounce";
import { useEffect, useRef, useState } from "react";
import Recaptcha from "react-google-recaptcha";
import { useHistory, useLocation } from "react-router-dom";
import { useReset2FAMutation } from "services/arbitraryApi";
import TwoFaGenerated from "./components/TwoFaGenerated";





const Reset2FA = () => {
  const toast = useToast();
  const history = useHistory();
  const location = useLocation();
  const [activeOption, setActiveOption] = useState("");
  const { login } = useAuth();

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "2FAResetOpion",
    defaultValue: "",
    onChange: (r) => setActiveOption(r),
  })

  const group = getRootProps()

  const searchParams = new URLSearchParams(location.search);
  const [params] = useState(searchParams.toString());
  const [loading, setLoading] = useState(false);
  const [resetState, setResetState] = useState({step: "", data: null});
  const [enableBackButton, setEnableBackButton] = useState(true);
  const redebounce = useDebounce();
  const recaptchaInstanceRef = useRef();

  const [reset2FA, { isSuccess, data }] =
  useReset2FAMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (navigator.onLine === true) {
        setLoading(true);
        const captcha = await recaptchaInstanceRef.current?.executeAsync();

        const reqData = {
          params,
          renew: String(activeOption).toLowerCase().includes("activate"),
          humanKey: captcha,
        };

        const response = await reset2FA(reqData);
        if(response?.error) {
          setLoading(false)
          let errorMsg = "Something went wrong";
          if(response?.error?.data?.error) {
            const errorMsgs = String(response?.error?.data?.error).split(": ");
            errorMsg = errorMsgs[1] || errorMsgs[0];
          }
          toast({
            position: "bottom-right",
            title: "Oops!!",
            description: errorMsg,
            status: "error",
            duration: 9000,
            isClosable: true,
          });
          redebounce(() => setEnableBackButton(true), "back-button", 1000)()
          return;
        } 
        // if(!reqData.renew) {
      //     login(data?.token, secondsToMilliseconds(data?.exp), true, data);
      //     history.replace(constant.PAGES.HOME);
      // }
        
      } else {
        // console.log(error, "errrrr");
        toast({
          position: "bottom-right",
          title: "Network Error!!",
          description: "Please check your network connection",
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isSuccess && data) {
      recaptchaInstanceRef.current?.reset();

      toast({
        position: "bottom-right",
        title: "Success",
        description: "2FA updated successfully.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data]);

  useEffect(() => {
    (async () => {
      const renew = String(activeOption).toLowerCase().includes("activate");

      if (isSuccess && data) {
        await recaptchaInstanceRef.current?.reset();

        (() => {
          if(!renew) {
            login(data?.token, secondsToMilliseconds(data?.exp), true, data);
            redebounce(() => history.replace(constant.PAGES.HOME), "redirect", 2000)();
          } else {
            setResetState({step: "complete", data})
          }
        })();
      }
    })();
    // eslint-disable-next-line
  }, [isSuccess, data, login]);

  useEffect(() => {
    if(resetState.step === "login") {
      login(data?.token, secondsToMilliseconds(data?.exp), true);
      redebounce(() => history.replace(constant.PAGES.HOME), "redirect", 2000)();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login, data, resetState.step])

  const onSafe = () => {
    setResetState({step: "login", data: null})
  }

  return (
    <>
    <VStack py={["10px", "20px"]} minH="100vh" alignItems="center">
      <Container maxW="lg">
        <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
          <VStack>
            <Box
              w={["100px", "initial"]}
              as={Logo}
              onClick={() => {
                // logout();
                history.replace("/");
              }}
            />
            <Text
              textAlign="center"
              fontSize={["32px", "3xl"]}
              mt="24px !important">
              {resetState.step === "complete" ? "New Two-Factor Authentication Secret" : "Reset 2FA" }
            </Text>
            <Text
              textAlign="center"
              fontSize={["sm", "md"]}
              color="#4e4b66"
              //   mt="24px !important"
            >
              {resetState.step === "complete" ? 
              "Complete your two-factor authentication setup by scanning the google authenticator QR Code below or copying the secret." : "Select an option to continue"}
            </Text>
          </VStack>

          {!resetState.step && <Box as="form" mt="50px" onSubmit={handleSubmit}>
            <VStack>
              <FormControl>
              <HStack {...group} justifyContent="center">
                {["Disable old 2FA ", "Activate new 2FA"].map((value) => {
                  const radio = getRadioProps({ value })
                  return (
                    <RadioCard key={value} {...radio}>
                      {value}
                    </RadioCard>
                  )
                })}
              </HStack>
              </FormControl>
              <Recaptcha
                ref={recaptchaInstanceRef}
                sitekey={process.env.REACT_APP_RECAPTCHA}
                size={"invisible"}
              />

              <Button
                isLoading={loading}
                disabled={!activeOption}
                minW="100%"
                minH="56px"
                fontWeight="normal"
                mt="30px !important"
                type="submit">
                Proceed
              </Button>
            </VStack>
          </Box>}
          {resetState.step === "complete" && <TwoFaGenerated generate2faData={resetState.data} onSafe={onSafe} />}
        </Box>
      </Container>
    </VStack>
    {enableBackButton && 
      <VStack gridGap="2rem" display="flex" justifyContent="center">
        <Box
          w={["100px", "initial"]}
          as={"div"}
          mt={["5rem", "10rem"]}
          cursor="pointer"
          onClick={() => {
            history.replace("/");
          }}>
          <button
            style={{
              color: "#03A438",
              cursor: "pointer",
            }}>
            Back to login
          </button>
        </Box>
      </VStack>}
    </>
  );
};

export default Reset2FA;

function RadioCard(props) {
  const { getInputProps, getCheckboxProps } = useRadio(props)

  const input = getInputProps()
  const checkbox = getCheckboxProps()

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        cursor="pointer"
        borderWidth="1px"
        borderRadius="md"
        boxShadow="md"
        _checked={{
          bg: "teal.600",
          color: "white",
          borderColor: "teal.600",
        }}
        _focus={{
          boxShadow: "outline",
        }}
        px={5}
        py={3}
      >
        {props.children}
      </Box>
    </Box>
  )
}